var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxInfoCircleGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33398C4.32416 1.33398 1.3335 4.32465 1.3335 8.00065C1.3335 11.6767 4.32416 14.6673 8.00016 14.6673C11.6762 14.6673 14.6668 11.6767 14.6668 8.00065C14.6668 4.32465 11.6762 1.33398 8.00016 1.33398ZM8.00016 13.334C5.0595 13.334 2.66683 10.9413 2.66683 8.00065C2.66683 5.05998 5.0595 2.66732 8.00016 2.66732C10.9408 2.66732 13.3335 5.05998 13.3335 8.00065C13.3335 10.9413 10.9408 13.334 8.00016 13.334Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 7.33268H8.66683V11.3327H7.3335V7.33268ZM7.3335 4.66602H8.66683V5.99935H7.3335V4.66602Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxInfoCircleGrey);
export default __webpack_public_path__ + "static/media/bx-info-circle-grey.edf3cd461ce9c5409834846032638412.svg";
export { ForwardRef as ReactComponent };